import { FC, useEffect, useRef, useState } from 'react';

import { PunchupDateRange } from 'features/common/components/Punchup/primitives/forms/pickers/PunchupDateRange';
import { GraphDisplayInfo } from './types';
import { PunchupSetTimelineZoom } from './PunchupSetTimelineZoom';
import styles from './TimelineControls.module.css';

const ICON_ONLY_THRESHOLD = 260;

export const TimelineControls: FC<GraphDisplayInfo> = ({
	setDisplay,
	displayWindow,
	minDate,
	maxDate,
	windowStartDate,
	windowEndDate,
	setDateRange,
}) => {
	const containerRef = useRef<HTMLDivElement>(null);
	const [iconOnly, setIconOnly] = useState(false);

	useEffect(() => {
		const el = containerRef.current;
		if (!el) return;
		const obs = new ResizeObserver((entries) => {
			setIconOnly(entries[0].contentRect.width < ICON_ONLY_THRESHOLD);
		});
		obs.observe(el);
		return () => obs.disconnect();
	}, []);

	return (
		<div ref={containerRef} className={styles.timelineContainer}>
			{minDate && maxDate && setDateRange && (
				<PunchupDateRange
					startDate={windowStartDate ?? minDate}
					endDate={windowEndDate ?? maxDate}
					minDate={minDate}
					maxDate={maxDate}
					onChange={setDateRange}
					iconOnly={iconOnly}
				/>
			)}
			<PunchupSetTimelineZoom setDisplay={setDisplay} displayWindow={displayWindow} />
		</div>
	);
};
